import styled, { css } from "styled-components";
import { getPropertyByMedia, getThemeMedia, getThemeSpace, getThemeTokenParser } from "../helpers";
export const Flex = styled.div `
	display: flex;
	gap: ${getThemeSpace("16")};
	${({ direction }) => getPropertyByMedia("flex-direction", direction, "row")}
	${({ alignSelf }) => getPropertyByMedia("align-self", alignSelf, "initial")}
	${({ alignItems }) => getPropertyByMedia("align-items", alignItems, "initial")}
	${({ justifyContent }) => getPropertyByMedia("justify-content", justifyContent, "initial")}
	${({ rowGap }) => getPropertyByMedia("row-gap", rowGap)}
	${({ columnGap }) => getPropertyByMedia("column-gap", columnGap)}
	${({ position }) => getPropertyByMedia("position", position, "initial")}
	${({ top }) => getPropertyByMedia("top", top)}
	${({ right }) => getPropertyByMedia("right", right)}
	${({ bottom }) => getPropertyByMedia("bottom", bottom)}
	${({ left }) => getPropertyByMedia("left", left)}
	${({ pointerEvents }) => getPropertyByMedia("pointer-events", pointerEvents)}
	${({ cursor }) => getPropertyByMedia("cursor", cursor)}

	${({ padding }) => getPropertyByMedia("padding", padding)}
	${({ margin }) => getPropertyByMedia("margin", margin)}
	${({ border }) => getPropertyByMedia("border", border)}
	${({ borderRadius }) => getPropertyByMedia("border-radius", borderRadius)}
	${({ borderWidth }) => getPropertyByMedia("border-width", borderWidth)}
	${({ borderStyle }) => getPropertyByMedia("border-style", borderStyle)}
	${({ backgroundColor }) => getPropertyByMedia("background-color", getThemeTokenParser(backgroundColor, "colors"))}
	${({ borderColor }) => getPropertyByMedia("border-color", getThemeTokenParser(borderColor, "colors"))}

	${({ height }) => getPropertyByMedia("height", height)}
	${({ width }) => getPropertyByMedia("width", width)}
	${({ maxWidth }) => getPropertyByMedia("max-width", maxWidth)}
	${({ minWidth }) => getPropertyByMedia("min-width", minWidth)}
	${({ maxHeight }) => getPropertyByMedia("max-height", maxHeight)}
	${({ minHeight }) => getPropertyByMedia("min-height", minHeight)}

	${({ textAlign }) => getPropertyByMedia("text-align", textAlign)}

	${({ display }) => display && getPropertyByMedia("display", display, "flex")}
	${({ order }) => getPropertyByMedia("order", order)}
	${({ wrap }) => getPropertyByMedia("flex-wrap", wrap, "initial")}
	${({ flex }) => getPropertyByMedia("flex", flex, "initial")}

	${({ zIndex }) => getPropertyByMedia("z-index", zIndex, "initial")}
	${({ visibility }) => getPropertyByMedia("visibility", visibility, "visible")}

	${({ overflow }) => getPropertyByMedia("overflow", overflow)}

	${({ whiteSpace }) => getPropertyByMedia("white-space", whiteSpace)}
	${({ opacity }) => getPropertyByMedia("opacity", opacity)}
	${({ transition }) => getPropertyByMedia("transition", transition)}
	${({ backgroundImage }) => getPropertyByMedia("backgroundImage", backgroundImage)}
	${({ filter }) => getPropertyByMedia("filter", filter)}

	${({ noShrink }) => noShrink &&
    css `
			flex-shrink: 0;
		`}

	${({ gap }) => gap
    ? getPropertyByMedia("gap", gap)
    : css `
					@media screen {
						@media (min-width: ${getThemeMedia("large")}) {
							gap: ${getThemeSpace("32")};
						}
					}
			  `}
`;
//# sourceMappingURL=index.js.map